export default {
  'caas.self.account': '账号',
  'caas.self.name': '姓名',
  'caas.self.phone': '手机/电话',
  'caas.self.isauthen': '是否实名认证',
  'caas.self.update.basic': '变更基本信息',
  'caas.self.update.password': '变更密码',
  'caas.self.real.authentication': '实名认证',
  'caas.self.bind.wechat': '绑定微信'
}
